import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function TermsOfService() {
  return (
    <div
      data-testid="terms-page"
      className="min-h-screen bg-[#0F2240] text-white"
    >
      <Header />
      <main className="pt-32 pb-20 md:pt-40 md:pb-28">
        <article className="max-w-3xl mx-auto px-6 md:px-10">
          <div className="flex items-center gap-3 mb-6">
            <div className="h-px w-10 bg-[#B89968]" />
            <span className="text-[#B89968] text-xs uppercase tracking-[0.32em]">
              Legal
            </span>
          </div>
          <h1
            data-testid="terms-heading"
            className="font-serif-display text-4xl sm:text-5xl text-white leading-tight mb-4"
          >
            Terms of Service
          </h1>
          <p className="text-[#94A3B8] text-sm mb-12">
            Please read these terms carefully before submitting an inquiry.
          </p>

          <Section title="No Attorney-Client Relationship">
            Submission of this form does not create an attorney-client
            relationship. An attorney-client relationship is established only
            through a signed retainer agreement.
          </Section>

          <Section title="Consent to Contact">
            By submitting this form, you authorize Newman Injury Law to contact
            you by phone at the number provided to discuss your case. You will
            not receive text messages from this system.
          </Section>

          <Section title="Case Evaluation">
            Submission does not guarantee representation. Newman Injury Law
            reserves the right to decline representation based on case
            evaluation, conflicts of interest, or capacity limitations.
          </Section>

          <Section title="Information Accuracy">
            You agree that all information provided is true and accurate to the
            best of your knowledge.
          </Section>

          <Section title="Statute of Limitations">
            Personal injury claims are subject to strict filing deadlines.
            Submitting this form does not toll or extend any applicable statute
            of limitations. Prompt consultation is recommended.
          </Section>

          <div className="mt-16 pt-8 border-t border-[#B89968]/15 flex flex-wrap gap-6 items-center">
            <Link
              to="/"
              data-testid="back-to-home"
              className="text-[#B89968] hover:text-[#CFB079] uppercase tracking-[0.22em] text-xs transition-colors"
            >
              ← Back to Home
            </Link>
            <Link
              to="/privacy"
              className="text-[#94A3B8] hover:text-white uppercase tracking-[0.22em] text-xs transition-colors"
            >
              Privacy Policy
            </Link>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section className="mb-10">
      <h2 className="font-serif-display text-xl md:text-2xl text-white mb-3">
        {title}
      </h2>
      <p className="text-[#CBD5E1] leading-relaxed">{children}</p>
    </section>
  );
}
